import { useEffect, useState } from 'react';

const KEY = 'lex_cookie_choice';

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      setVisible(!localStorage.getItem(KEY));
    } catch {
      setVisible(false);
    }
  }, []);

  const choose = (value: 'all' | 'necessary'): void => {
    try {
      localStorage.setItem(KEY, value);
    } catch {
      // localStorage может быть недоступен — просто скрываем баннер.
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-[70] md:inset-x-auto md:bottom-5 md:right-5 md:max-w-md">
      <div className="rounded-2xl border border-line bg-white/97 p-4 shadow-[0_18px_50px_rgba(10,28,64,0.2)] backdrop-blur-xl">
        <p className="text-[14px] font-semibold text-ink">Мы используем cookie</p>
        <p className="mt-1 text-[12.5px] leading-[18px] text-muted">
          Необходимые cookie нужны для входа и работы чата. Аналитические помогают улучшать
          сервис. Подробнее — в{' '}
          <a href="/privacy" className="font-semibold text-accent">
            политике конфиденциальности
          </a>
          .
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => choose('all')}
            className="rounded-xl bg-ink-gradient px-4 py-2 text-[13px] font-semibold text-white"
          >
            Принять все
          </button>
          <button
            type="button"
            onClick={() => choose('necessary')}
            className="rounded-xl border border-line bg-white px-4 py-2 text-[13px] font-semibold text-ink"
          >
            Только необходимые
          </button>
        </div>
      </div>
    </div>
  );
}
